export default __webpack_public_path__ + "static/media/25.2ac0c69c.png";